import { PropsWithChildren } from "react";

export const Section = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <section className="h-full w-full bg-jutro-new-warm-gray-100 xl:w-3/4 xl:pr-8 2xl:pr-24">
      {children}
    </section>
  );
};
